export function normalizeMakeKey(make) {
  return String(make || "")
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");
}

export function normalizeMakeLabel(make) {
  const key = normalizeMakeKey(make);
  if (!key) return "";
  return key
    .split(" ")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function dedupeNormalizedMakes(makes = []) {
  const map = new Map();
  makes.forEach((make) => {
    const key = normalizeMakeKey(make);
    if (!key) return;
    if (!map.has(key)) {
      map.set(key, normalizeMakeLabel(make));
    }
  });
  return [...map.values()].sort((a, b) => a.localeCompare(b, "es"));
}

export function listingMatchesMakeFilter(listingMake, selectedMake) {
  return normalizeMakeKey(listingMake) === normalizeMakeKey(selectedMake);
}
